import mutations from './mutations'
import state from './state'
export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/invoice.js